import {
  Badge,
  Box,
  Button,
  Flex,
  Stack,
  Tag,
  Text,
  MenuItem,
  useColorModeValue,
} from "@chakra-ui/react";

import React from "react";
import { FiExternalLink } from "react-icons/fi";
import { Link } from "react-router-dom";
import HeaderWithActions from "../../components/HeaderWithActions";
import ListView from "../../components/ListView";
import Meta from "../../components/Meta";
import { useSchemaQuery } from "../../react-apollo-introspection";
import { DELETE, FETCH_ALL } from "./graphql";
import { setup } from "./setup";
import PlaceById from "./components/PlaceById";
import AdvertById from "./components/AdvertById";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

const List = ({ title }) => {
  const [fetchData, { loading, error, data }] =
    useSchemaQuery("arearequests_List");
  console.log("data", data)
  const columns = [
    {
      Header: "Request",
      accessor: "timestamp",
      disableSortBy: true,
      Cell: ({ row }) => (
        <Flex gap={5} align="center">
          {dayjs(row.original.timestamp).fromNow(true)} ago
        </Flex>
      ),
    },
    {
      Header: "Count",
      accessor: "count",
      disableSortBy: true,
      Cell: ({ row }) => (
        <Flex gap={5} align="center" justifyContent="center">
          <Text fontWeight={"bold"} textAlign="right">{row.original.count}</Text>
        </Flex>
      ),
    },
    {
      Header: "Location Name",
      accessor: "location.name",
      disableSortBy: true,
      Cell: ({ row }) => (
        <Flex gap={5} align="center">
          <Link to={`/${setup.model}/edit/${row?.original?._id}`}>
          <Button variant='link'>{row.original.location.name}</Button>  
          </Link>
        </Flex>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      disableSortBy: true,
      Cell: ({ row }) => (
        <Flex gap={5} align="center">
          <Badge
            bg={
              row?.original?.status === "completed"
                ? "green.300"
                : "yellow.100"
            }
          >
            {row?.original?.status}
          </Badge>
        </Flex>
      ),
    },
    {
      Header: 'Location Types',
      accessor: 'location.types',
      disableSortBy: false,
      Cell: ({ value }) => {
        return (
          <Flex gap={5}>
            {value?.map((el, i) => {
              return (
                <Tag
                  size={'md'}
                  key={`${el}-${i}`}
                  variant='solid'
                  colorScheme={value == 'custom_locality' ? 'teal' : 'blue'}
                  textTransform={'capitalize'}
                  fontWeight='bold'
                >
                  <Text px='0.5em'>{el.replaceAll('_', ' ')}</Text>
                </Tag>
              );
            })}
          </Flex>
        );
      },
    },
  ];

  const filters = [
    {
      component: 'text',
      label: 'Types',
      name: 'types',
      placeholder: 'Select Location Type',
    }
  ];

  return (
    <Meta title={setup.title}>
      <HeaderWithActions title={setup.title}/>
      <Box
        mt="25px"
        bg={useColorModeValue("white", "gray.700")}
        shadow="base"
        rounded={{
          base: "md",
          sm: "xl",
        }}
        w="100%"
      >
        <ListView
          setup={setup}
          fetchData={fetchData}
          data={data?.[FETCH_ALL]}
          loading={loading}
          error={error}
          gqlDelete={DELETE}
          columns={columns}
          filters={filters}
        />
      </Box>
    </Meta>
  );
};

export default List;
